module.exports = __webpack_public_path__ + "static/media/fullsize.ee6ca6e3.png";